import { Route, Routes, Outlet } from "react-router-dom";
import NoRoutePage from "../components/NoRoutePage";
import ChooseLogin from "../components/ChooseLogin";
import AdminLogin from "./Auth/Admin/Login";
import AdminSignUp from "./Auth/Admin/SignUp";
import AdminLoginAdminInvite from "./Auth/Admin/LoginAdminInvite";
import DashboardContainer from "./ESA/Dashboard/DashboardContainer";
import Home from "./ESA/Dashboard/Home";
import Employees from "./ESA/Dashboard/Employees";
import Onboarding from "./ESA/Onboarding";
import Programs from "./ESA/Dashboard/Programs";
import Reports from "./ESA/Dashboard/Reports";
import Settings from "./ESA/Dashboard/Settings";
import PrivateRoute from "../routes/PrivateRoute";
import AdminRoleRequired from "../routes/AdminRoleRequired";
import EmployeeLogin from "./Auth/Employee/Login";
import EmployeeRoleRequired from "../routes/EmployeeRoleRequired";
import EmployeeAccountStatus from "./ESA/Employee/AccountStatus";
import EmployeeDashboard from "./ESA/Employee/Account";
import EmployeeAccount from "./ESA/Employee/Account/Account";
import EmployeeTransfers from "./ESA/Employee/Transfers";
import EmployeeTransferFlow from "./ESA/Employee/Transfers/TransferFlow";
import EmployeeTransferInitiated from "./ESA/Employee/Transfers/05TransferInitiated";
import EmployeeTransferError from "./ESA/Employee/Transfers/06TransferError";
import EmployeeSettings from "./ESA/Employee/Settings";
import EmployeeAccountStatements from "./ESA/Employee/Statements";
import EmployeeStatementDetail from "./ESA/Employee/Statements/StatementDetail";
import EmployeeAccountInviteCoworkers from "./ESA/Employee/InviteCoworkers";
import EmployeeActivateCard from "./ESA/Employee/ActivateCard";
import EmployeeDebitCardInfo from "./ESA/Employee/DebitCardInfo";
import EmployeeDebitCardChangePin from "./ESA/Employee/DebitCardChangePin";
import EmployeeDebitCardChangeAddress from "./ESA/Employee/DebitCardChangeAddress";
import EmployeeDebitCardOrderNew from "./ESA/Employee/DebitCardOrderNewCard";
import EmployeeChangeContribution from "./ESA/Employee/ChangeContribution";
import EmployeeTransactions from "./ESA/Employee/Transactions";
import EmployeeRequestCard from "./ESA/Employee/RequestCard";
import EmployeeRequestCardSuccess from "./ESA/Employee/RequestCard/RequestCardSuccess";

import {
  LOGIN,
  LOGIN_ADMIN_INVITE,
  SIGN_UP,
  ESA_PARENT_ROUTE,
  ADMIN_PARENT_ROUTE,
  ADMIN_HOME,
  ADMIN_PROGRAMS,
  ADMIN_EMPLOYEES,
  ADMIN_REPORTS,
  ADMIN_SETTINGS,
  ADMIN_ONBOARDING,
  ADMIN_DASHBOARD,
  EMPLOYEE_PARENT_ROUTE,
  EMPLOYEE_ACCOUNT,
  EMPLOYEE_ACCOUNT_STATUS,
  EMPLOYEE_TRANSFERS,
  EMPLOYEE_TRANSFERS_ADD_MONEY,
  EMPLOYEE_TRANSFERS_SEND_MONEY,
  EMPLOYEE_TRANSFER_INITIATED,
  EMPLOYEE_TRANSFER_ERROR,
  EMPLOYEE_SETTINGS,
  EMPLOYEE_ACCOUNT_STATEMENTS,
  EMPLOYEE_ACCOUNT_INVITE,
  EMPLOYEE_ACTIVATE_CARD,
  EMPLOYEE_DEBIT_CARD_INFO,
  EMPLOYEE_DEBIT_CARD_CHANGE_PIN,
  EMPLOYEE_DEBIT_CARD_CHANGE_ADDRESS,
  EMPLOYEE_DEBIT_CARD_NEW_CARD,
  EMPLOYEE_CHANGE_CONTRIBUTION,
  EMPLOYEE_TRANSACTIONS,
  EMPLOYEE_REQUEST_CARD,
  EMPLOYEE_REQUEST_CARD_SUCCESS,
} from "../routes/paths";

type Props = {};

/*
  NOTES ON ROUTES
  We have separate auth pages for admins and employees. The LOGIN path (ChooseLogin) is used so that
  we can redirect the user to a page that allows them to choose which login page they want to go to.
  For example, if their refresh token has expired rathat than adding logic to determine where to take them to
  We have that single page and they can pick which one.

*/
const Navigation = (props: Props) => {
  return (
    <Routes>
      <Route path={LOGIN} element={<ChooseLogin />} />
      <Route path={`${ADMIN_PARENT_ROUTE}/${LOGIN}`} element={<AdminLogin />} />
      <Route path={LOGIN_ADMIN_INVITE} element={<AdminLoginAdminInvite />} />
      <Route
        path={`${ADMIN_PARENT_ROUTE}/${SIGN_UP}`}
        element={<AdminSignUp />}
      />
      <Route
        path={`${EMPLOYEE_PARENT_ROUTE}/${LOGIN}`}
        element={<EmployeeLogin />}
      />
      <Route path={ESA_PARENT_ROUTE} element={<PrivateRoute />}>
        <Route path={ADMIN_PARENT_ROUTE} element={<AdminRoleRequired />}>
          <Route path={ADMIN_ONBOARDING} element={<Onboarding />}></Route>
          <Route path={ADMIN_DASHBOARD} element={<DashboardContainer />}>
            <Route path={ADMIN_HOME} element={<Home />}></Route>
            <Route path={ADMIN_PROGRAMS} element={<Programs />}></Route>
            <Route path={ADMIN_EMPLOYEES} element={<Employees />}></Route>
            <Route path={ADMIN_REPORTS} element={<Reports />}></Route>
            <Route path={ADMIN_SETTINGS} element={<Settings />}></Route>
          </Route>
        </Route>
        <Route path={EMPLOYEE_PARENT_ROUTE} element={<EmployeeRoleRequired />}>
          <Route
            path={EMPLOYEE_ACCOUNT_STATUS}
            element={<EmployeeAccountStatus />}
          />
          <Route path={EMPLOYEE_ACCOUNT} element={<EmployeeDashboard />}>
            <Route path={""} element={<EmployeeAccount />} />
            <Route
              path={EMPLOYEE_ACCOUNT_INVITE}
              element={<EmployeeAccountInviteCoworkers />}
            />
            <Route
              path={EMPLOYEE_ACTIVATE_CARD}
              element={<EmployeeActivateCard />}
            />
            <Route
              path={EMPLOYEE_DEBIT_CARD_INFO}
              element={<EmployeeDebitCardInfo />}
            />
            <Route
              path={`${EMPLOYEE_DEBIT_CARD_INFO}/${EMPLOYEE_DEBIT_CARD_CHANGE_PIN}`}
              element={<EmployeeDebitCardChangePin />}
            />
            <Route
              path={`${EMPLOYEE_DEBIT_CARD_INFO}/${EMPLOYEE_DEBIT_CARD_CHANGE_ADDRESS}`}
              element={<EmployeeDebitCardChangeAddress />}
            />
            <Route
              path={`${EMPLOYEE_DEBIT_CARD_INFO}/${EMPLOYEE_DEBIT_CARD_NEW_CARD}`}
              element={<EmployeeDebitCardOrderNew />}
            />
            <Route
              path={EMPLOYEE_CHANGE_CONTRIBUTION}
              element={<EmployeeChangeContribution />}
            />
            <Route
              path={EMPLOYEE_TRANSACTIONS}
              element={<EmployeeTransactions />}
            />
            <Route path={EMPLOYEE_TRANSFERS} element={<EmployeeTransfers />} />
            <Route
              path={`${EMPLOYEE_TRANSFERS}/${EMPLOYEE_TRANSFERS_ADD_MONEY}`}
              element={<EmployeeTransferFlow direction="add_money" />}
            />
            <Route
              path={`${EMPLOYEE_TRANSFERS}/${EMPLOYEE_TRANSFERS_SEND_MONEY}`}
              element={<EmployeeTransferFlow direction="send_money" />}
            />
            <Route path={EMPLOYEE_SETTINGS} element={<EmployeeSettings />} />
            <Route
              path={`${EMPLOYEE_SETTINGS}/${EMPLOYEE_ACCOUNT_STATEMENTS}`}
              element={<EmployeeAccountStatements />}
            />
            <Route
              path={`${EMPLOYEE_SETTINGS}/${EMPLOYEE_ACCOUNT_STATEMENTS}/:yearMonth`}
              element={<EmployeeStatementDetail />}
            />
            <Route
              path={`${EMPLOYEE_SETTINGS}/${EMPLOYEE_REQUEST_CARD}`}
              element={<EmployeeRequestCard />}
            />
          </Route>
          <Route
            path={`${EMPLOYEE_TRANSFER_INITIATED}`}
            element={<EmployeeTransferInitiated />}
          />
          <Route
            path={`${EMPLOYEE_TRANSFER_ERROR}`}
            element={<EmployeeTransferError />}
          />
          <Route
            path={`${EMPLOYEE_REQUEST_CARD_SUCCESS}`}
            element={<EmployeeRequestCardSuccess />}
          />
        </Route>
      </Route>
      <Route path="*" element={<NoRoutePage />} />
    </Routes>
  );
};

export default Navigation;
